module.exports = __webpack_public_path__ + "img/service.ff15facd.webp";